import React from 'react';
import Wrapper from "../components/layout/Wrapper";
import Picture1 from "../assets/Images/picture1.png"
import CodingEnv from "../assets/Images/coding-env.png"
import Access from "../assets/Images/access-anywhere.png"
import {FontAwesomeIcon} from "@fortawesome/react-fontawesome";
import Header from "../components/layout/Header";
import Footer from "../components/layout/Footer";
import {faAndroid} from "@fortawesome/free-brands-svg-icons";
import ButtonLinkHref from "../components/elements/ButtonLinkHref";
import SEO from "../components/layout/SEO";
import { useLanguage } from "../context/LanguageProvider";
const Home = () => {

    const {t} = useLanguage();

    return (
        <>
            <SEO
                title={t.seo.home.title}
                description={t.seo.home.description}
                path="/"
            />
            <Header/>
            <main className='min-h-screen'>
                <section className="relative flex my-10 md:my-16">
                    <Wrapper>
                        <div className="relative z-10">
                            <div className="text-light-primary">
                                <div
                                    className="w-1/2 lg:w-1/6 md:w-1/4 m-auto flex justify-center items-center relative">
                                    <img
                                        src={Picture1}
                                        alt="teenage boy coding on phone using codepro app"
                                        className="w-full"
                                    />
                                </div>
                                <h1 className="text-3xl md:text-3xl text-center lg:text-4xl mt-10 md:mt-12 xl:text-5xl flex justify-center w-full font-bold leading-relaxed drop-shadow">
                                    {t.home.heading}
                                </h1>
                                <p className="mt-8 md:mt-10 flex justify-center text-center text-2xl lg:text-lg drop-shadow">
                                    {t.home.subtitle}
                                </p>
                                <div
                                    className="w-100 mt-12 md:mt-10 gap-y-5 md:gap-x-8 flex flex-col md:flex-row justify-center">
                                    <ButtonLinkHref
                                        to={t.home.downloadUrlBazaar}
                                        openInNewTab
                                        className={"gap-x-2 w-full md:w-fit"}
                                    >
                    <span>
                        {t.home.downloadBazaar}
                    </span>
                                        <FontAwesomeIcon icon={faAndroid}/>
                                    </ButtonLinkHref>

                                    <ButtonLinkHref
                                        to={t.home.downloadUrlMyket}
                                        className={"gap-x-2 w-full md:w-fit"}
                                        openInNewTab
                                    >
                    <span>
                        {t.home.downloadMyket}
                    </span>
                                        <FontAwesomeIcon icon={faAndroid}/>
                                    </ButtonLinkHref>
                                </div>
                            </div>
                        </div>
                    </Wrapper>
                </section>
            </main>
            <Footer/>
        </>
    )
        ;
};

export default Home;
